import { Avatar, Box, Paper, Typography, useTheme } from '@mui/material';
import { format } from 'date-fns';

import { ChatMessage as ChatMessageType } from '@/types/chatWidget';

interface ChatMessageProps {
  message: ChatMessageType;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const theme = useTheme();
  const isUser = message.sender === 'user';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        mb: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: isUser ? '10px' : 2,
          maxWidth: '75%',
          borderRadius: isUser ? '6px' : 2,
          backgroundColor: isUser ? '#E8EAFD' : '#f5f5f5',
          color: isUser ? '#0D1C8C' : theme.palette.text.primary,
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 1.285,
            textAlign: isUser ? 'right' : 'left',
          }}
        >
          {message.content}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            textAlign: 'right',
            mt: 0.5,
            opacity: 0.8,
            fontSize: '0.7rem',
            display: 'none', // Hide timestamp for now based on Figma design
          }}
        >
          {format(new Date(message.timestamp), 'HH:mm')}
        </Typography>
      </Paper>
      {isUser && (
        <Avatar
          src="https://randomuser.me/api/portraits/women/68.jpg"
          sx={{
            width: 32,
            height: 32,
            ml: 1,
            alignSelf: 'flex-end',
            mb: 0.5,
            display: 'none', // Hide avatar for user messages based on Figma design
          }}
        />
      )}
    </Box>
  );
};

export default ChatMessage;
